function IconLockComponent() {
  return (
    <svg
      width="13"
      height="15"
      viewBox="0 0 13 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4635 6.51404H2.76953C1.66496 6.51404 0.769531 7.40947 0.769531 8.51404V11.66C0.769531 12.7646 1.66496 13.66 2.76953 13.66H10.4635C11.5681 13.66 12.4635 12.7646 12.4635 11.66V8.51404C12.4635 7.40947 11.5681 6.51404 10.4635 6.51404Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.36816 6.514V3.914C3.36816 3.48721 3.45223 3.06459 3.61556 2.67028C3.77888 2.27597 4.01828 1.91769 4.32007 1.6159C4.62186 1.31411 4.98013 1.07472 5.37444 0.911393C5.76875 0.748065 6.19137 0.664001 6.61816 0.664001C7.04496 0.664001 7.46758 0.748065 7.86189 0.911393C8.25619 1.07472 8.61447 1.31411 8.91626 1.6159C9.21805 1.91769 9.45744 2.27597 9.62077 2.67028C9.7841 3.06459 9.86816 3.48721 9.86816 3.914V6.514"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export { IconLockComponent };
